// Created by hejikun on 2017/11/2 0002.
let register = [
  {
    path: '/register_reg',
    name: '医生注册',
    component: () => import('@/pages/register/index')
  },
  {
    path: '/user_regiter',
    name: '用户登录注册',
    component: () => import('@/pages/register/user_regiter')
  },
  {
    path: '/Identity_verification',
    name: '身份验证',
    component: () => import('@/pages/register/Identity_verification')
  },
  {
    path: '/register_ent',
    name: '医生信息录入',
    component: () => import('@/pages/register/entering')
  },
  {
    path: '/register_down',
    name: '注册成功',
    component: () => import('@/pages/register/download')
  },
  {
    path: '/register_protocol',
    name: '注册协议',
    component: () => import('@/pages/register/register_protocol')
  },
  {
    path: '/change_binding',
    name: '绑定用户',
    component: () => import('@/pages/register/change_binding')
  },
  {
    path: '/change_phone',
    name: '绑定/换绑手机',
    component: () => import('@/pages/register/change_phone')
  },
  {
    path: '/service_protocol',
    name: '服务协议',
    component: () => import('@/pages/register/service_protocol')
  },
  {
    path: '/confirm_change_bingding',
    name: '确认换绑',
    component: () => import('@/pages/register/confirm_change_bingding')
  }
]

export default register
